import { useEffect, useState } from "react";
import API from "../api";

function Events() {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const emptyForm = {
    title: "",
    event_date: "",
    event_time: "",
    location: "",
    grade: "apprenti",
    agenda: "",
  };

  const [form, setForm] = useState(emptyForm);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user.role === "admin";

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await API.get("/events");
      setEvents(res.data);
    } catch (err) {
      console.error("Erreur events:", err);
      alert("Impossible de charger les tenues");
    }
  };

  const fetchParticipants = async (eventId) => {
    if (!isAdmin) return;

    try {
      const res = await API.get(`/events/${eventId}/participants`);
      setParticipants(res.data);
    } catch (err) {
      console.error("Erreur participants:", err);
    }
  };

  const createEvent = async () => {
    if (!form.title || !form.event_date || !form.event_time || !form.location) {
      alert("Merci de remplir le titre, la date, l'heure et le lieu");
      return;
    }

    try {
      setLoading(true);

      await API.post("/events", {
        ...form,
        allow_attendance: true,
        allow_agapes: true,
      });

      setForm(emptyForm);
      await fetchEvents();

      alert("Tenue ajoutée");
    } catch (err) {
      console.error("Erreur création tenue:", err);
      alert("Impossible d'ajouter la tenue");
    } finally {
      setLoading(false);
    }
  };

  const openEvent = async (event) => {
    setSelectedEvent(event);
    setEditMode(false);

    setForm({
      title: event.title || "",
      event_date: event.event_date ? event.event_date.slice(0, 10) : "",
      event_time: event.event_time ? event.event_time.slice(0, 5) : "",
      location: event.location || "",
      grade: event.grade || "apprenti",
      agenda: event.agenda || "",
    });

    await fetchParticipants(event.id);
  };

  const updateRegistration = async (nextAttending, nextAgapes) => {
    try {
      await API.post(`/events/${selectedEvent.id}/register`, {
        attending: nextAttending,
        agapes: nextAgapes,
      });

      const updated = {
        ...selectedEvent,
        attending: nextAttending ? 1 : 0,
        agapes: nextAgapes ? 1 : 0,
      };

      setSelectedEvent(updated);

      setEvents((prev) =>
        prev.map((e) => (e.id === updated.id ? updated : e))
      );

      await fetchParticipants(selectedEvent.id);
    } catch (err) {
      console.error("Erreur inscription:", err);
      alert("Impossible de mettre à jour l'inscription");
    }
  };

  const updateEvent = async () => {
    if (!form.title || !form.event_date || !form.event_time || !form.location) {
      alert("Merci de remplir le titre, la date, l'heure et le lieu");
      return;
    }

    try {
      await API.put(`/events/${selectedEvent.id}`, form);

      const updated = {
        ...selectedEvent,
        ...form,
      };

      setSelectedEvent(updated);
      setEditMode(false);
      await fetchEvents();

      alert("Tenue modifiée");
    } catch (err) {
      console.error("Erreur modification tenue:", err);
      alert("Impossible de modifier la tenue");
    }
  };

  const deleteEvent = async () => {
    if (!window.confirm("Supprimer cette tenue ?")) return;

    try {
      await API.delete(`/events/${selectedEvent.id}`);
      setSelectedEvent(null);
      await fetchEvents();
    } catch (err) {
      console.error("Erreur suppression tenue:", err);
      alert("Impossible de supprimer la tenue");
    }
  };

  const formatDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const formatTime = (time) => {
    if (!time) return "";
    return time.slice(0, 5);
  };

  const gradeLabel = {
    apprenti: "1er degré",
    compagnon: "2e degré",
    maitre: "3e degré",
  };

  const countTenue = participants.filter((p) => p.attending).length;
  const countAgapes = participants.filter((p) => p.agapes).length;

  const updateForm = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  if (selectedEvent) {
    const attending = !!selectedEvent.attending;
    const agapes = !!selectedEvent.agapes;

    return (
      <div style={styles.page}>
        <button style={styles.backButton} onClick={() => setSelectedEvent(null)}>
          ← Retour
        </button>

        {!editMode ? (
          <div style={styles.detailCard}>
            <div style={styles.badge}>{gradeLabel[selectedEvent.grade]}</div>

            <h1 style={styles.detailTitle}>{selectedEvent.title}</h1>

            <div style={styles.infoBox}>
              <p style={styles.info}>📅 {formatDate(selectedEvent.event_date)}</p>
              <p style={styles.info}>🕯️ {formatTime(selectedEvent.event_time)}</p>
              <p style={styles.info}>📍 {selectedEvent.location}</p>
            </div>

            <div style={styles.agendaBox}>
              <h2 style={styles.sectionTitle}>Ordre du jour</h2>
              <p style={styles.agendaText}>
                {selectedEvent.agenda || "Aucun ordre du jour renseigné."}
              </p>
            </div>

            <div style={styles.actions}>
              <button
                style={attending ? styles.activeButton : styles.goldButton}
                onClick={() => updateRegistration(!attending, agapes)}
              >
                {attending ? "✓ Inscrit à la tenue" : "Participer à la tenue"}
              </button>

              <button
                style={agapes ? styles.activeButton : styles.goldButton}
                onClick={() => updateRegistration(attending, !agapes)}
              >
                {agapes ? "✓ Inscrit aux agapes" : "Participer aux agapes"}
              </button>
            </div>

            {isAdmin && (
              <div style={styles.adminBox}>
                <h2 style={styles.sectionTitle}>Participants</h2>

                <div style={styles.counterRow}>
                  <div style={styles.counter}>
                    <strong>{countTenue}</strong>
                    <span>Tenue</span>
                  </div>

                  <div style={styles.counter}>
                    <strong>{countAgapes}</strong>
                    <span>Agapes</span>
                  </div>
                </div>

                {participants.length === 0 ? (
                  <p style={styles.empty}>Aucun inscrit pour le moment.</p>
                ) : (
                  participants.map((p) => (
                    <div key={p.id} style={styles.participant}>
                      <span>
                        {p.firstname} {p.lastname}
                      </span>
                      <span>
                        {p.attending ? "Tenue ✓" : "Tenue —"} /{" "}
                        {p.agapes ? "Agapes ✓" : "Agapes —"}
                      </span>
                    </div>
                  ))
                )}

                <button style={styles.goldButton} onClick={() => setEditMode(true)}>
                  Modifier la tenue
                </button>

                <button style={styles.deleteButton} onClick={deleteEvent}>
                  Supprimer la tenue
                </button>
              </div>
            )}
          </div>
        ) : (
          <div style={styles.formCard}>
            <h1 style={styles.detailTitle}>Modifier la tenue</h1>

            <input
              style={styles.input}
              placeholder="Titre"
              value={form.title}
              onChange={(e) => updateForm("title", e.target.value)}
            />

            <input
              style={styles.input}
              type="date"
              value={form.event_date}
              onChange={(e) => updateForm("event_date", e.target.value)}
            />

            <input
              style={styles.input}
              type="time"
              value={form.event_time}
              onChange={(e) => updateForm("event_time", e.target.value)}
            />

            <input
              style={styles.input}
              placeholder="Lieu"
              value={form.location}
              onChange={(e) => updateForm("location", e.target.value)}
            />

            <select
              style={styles.input}
              value={form.grade}
              onChange={(e) => updateForm("grade", e.target.value)}
            >
              <option value="apprenti">1er degré</option>
              <option value="compagnon">2e degré</option>
              <option value="maitre">3e degré</option>
            </select>

            <textarea
              style={styles.textarea}
              placeholder="Ordre du jour"
              value={form.agenda}
              onChange={(e) => updateForm("agenda", e.target.value)}
            />

            <button style={styles.goldButton} onClick={updateEvent}>
              Enregistrer
            </button>

            <button style={styles.secondaryButton} onClick={() => setEditMode(false)}>
              Annuler
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>Agenda des tenues</h1>

      {isAdmin && (
        <div style={styles.formCard}>
          <h2 style={styles.formTitle}>Ajouter une tenue</h2>

          <input
            style={styles.input}
            placeholder="Titre de la tenue"
            value={form.title}
            onChange={(e) => updateForm("title", e.target.value)}
          />

          <input
            style={styles.input}
            type="date"
            value={form.event_date}
            onChange={(e) => updateForm("event_date", e.target.value)}
          />

          <input
            style={styles.input}
            type="time"
            value={form.event_time}
            onChange={(e) => updateForm("event_time", e.target.value)}
          />

          <input
            style={styles.input}
            placeholder="Lieu"
            value={form.location}
            onChange={(e) => updateForm("location", e.target.value)}
          />

          <select
            style={styles.input}
            value={form.grade}
            onChange={(e) => updateForm("grade", e.target.value)}
          >
            <option value="apprenti">1er degré</option>
            <option value="compagnon">2e degré</option>
            <option value="maitre">3e degré</option>
          </select>

          <textarea
            style={styles.textarea}
            placeholder="Ordre du jour"
            value={form.agenda}
            onChange={(e) => updateForm("agenda", e.target.value)}
          />

          <button style={styles.goldButton} onClick={createEvent} disabled={loading}>
            {loading ? "Ajout..." : "Ajouter la tenue"}
          </button>
        </div>
      )}

      <div style={styles.list}>
        {events.length === 0 ? (
          <p style={styles.empty}>Aucune tenue prévue.</p>
        ) : (
          events.map((event) => (
            <div
              key={event.id}
              style={styles.card}
              onClick={() => openEvent(event)}
            >
              <div style={styles.cardTop}>
                <span style={styles.badge}>{gradeLabel[event.grade]}</span>
                <span style={styles.date}>{formatDate(event.event_date)}</span>
              </div>

              <h2 style={styles.cardTitle}>{event.title}</h2>

              <p style={styles.info}>🕯️ {formatTime(event.event_time)}</p>
              <p style={styles.info}>📍 {event.location}</p>

              <div style={styles.statusRow}>
                <span style={event.attending ? styles.statusOn : styles.statusOff}>
                  {event.attending ? "Tenue ✓" : "Tenue —"}
                </span>
                <span style={event.agapes ? styles.statusOn : styles.statusOff}>
                  {event.agapes ? "Agapes ✓" : "Agapes —"}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    padding: "24px",
    paddingBottom: "115px",
    background: "linear-gradient(180deg, #130b05 0%, #241509 100%)",
    color: "#fff7e8",
    boxSizing: "border-box",
  },

  title: {
    margin: "0 0 22px 0",
    fontSize: "30px",
    color: "#f7d48a",
  },

  formCard: {
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(247,212,138,0.22)",
    borderRadius: "24px",
    padding: "18px",
    marginBottom: "24px",
  },

  formTitle: {
    margin: "0 0 14px 0",
    color: "#f7d48a",
  },

  input: {
    width: "100%",
    padding: "14px",
    marginBottom: "12px",
    borderRadius: "16px",
    border: "1px solid rgba(255,255,255,0.18)",
    background: "rgba(0,0,0,0.35)",
    color: "#ffffff",
    fontSize: "16px",
    boxSizing: "border-box",
  },

  textarea: {
    width: "100%",
    minHeight: "130px",
    padding: "14px",
    marginBottom: "14px",
    borderRadius: "16px",
    border: "1px solid rgba(255,255,255,0.18)",
    background: "rgba(0,0,0,0.35)",
    color: "#ffffff",
    fontSize: "16px",
    lineHeight: "1.5",
    boxSizing: "border-box",
  },

  list: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  card: {
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(247,212,138,0.22)",
    borderRadius: "24px",
    padding: "18px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
  },

  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
  },

  badge: {
    display: "inline-block",
    background: "rgba(247,212,138,0.16)",
    border: "1px solid rgba(247,212,138,0.4)",
    color: "#f7d48a",
    borderRadius: "999px",
    padding: "6px 12px",
    fontSize: "13px",
    fontWeight: "700",
  },

  date: {
    color: "#e4d2a9",
    fontSize: "13px",
    textAlign: "right",
  },

  cardTitle: {
    margin: "0 0 12px 0",
    fontSize: "22px",
    color: "#ffffff",
  },

  info: {
    margin: "8px 0",
    color: "#f0dfbd",
    fontSize: "16px",
    lineHeight: "1.4",
  },

  statusRow: {
    display: "flex",
    gap: "10px",
    marginTop: "14px",
  },

  statusOn: {
    flex: 1,
    textAlign: "center",
    background: "rgba(77, 180, 105, 0.18)",
    color: "#b9f2c7",
    border: "1px solid rgba(77, 180, 105, 0.4)",
    borderRadius: "14px",
    padding: "9px",
    fontSize: "13px",
    fontWeight: "700",
  },

  statusOff: {
    flex: 1,
    textAlign: "center",
    background: "rgba(255,255,255,0.06)",
    color: "#d8c7a4",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "14px",
    padding: "9px",
    fontSize: "13px",
    fontWeight: "700",
  },

  backButton: {
    width: "100%",
    padding: "14px",
    marginBottom: "22px",
    borderRadius: "16px",
    border: "none",
    background: "linear-gradient(135deg, #d6a84f, #f7d48a)",
    color: "#201207",
    fontSize: "17px",
    fontWeight: "800",
  },

  detailCard: {
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(247,212,138,0.22)",
    borderRadius: "26px",
    padding: "20px",
  },

  detailTitle: {
    margin: "16px 0 16px 0",
    fontSize: "30px",
    color: "#ffffff",
  },

  infoBox: {
    background: "rgba(0,0,0,0.22)",
    borderRadius: "18px",
    padding: "12px 14px",
    marginBottom: "18px",
  },

  agendaBox: {
    marginTop: "18px",
    paddingTop: "18px",
    borderTop: "1px solid rgba(255,255,255,0.12)",
  },

  sectionTitle: {
    margin: "0 0 12px 0",
    color: "#f7d48a",
    fontSize: "21px",
  },

  agendaText: {
    whiteSpace: "pre-wrap",
    lineHeight: "1.65",
    fontSize: "17px",
    color: "#fff3d7",
    margin: 0,
  },

  actions: {
    marginTop: "22px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  goldButton: {
    width: "100%",
    padding: "15px",
    borderRadius: "16px",
    border: "none",
    background: "linear-gradient(135deg, #d6a84f, #f7d48a)",
    color: "#201207",
    fontSize: "17px",
    fontWeight: "800",
  },

  activeButton: {
    width: "100%",
    padding: "15px",
    borderRadius: "16px",
    border: "1px solid rgba(77, 180, 105, 0.45)",
    background: "rgba(77, 180, 105, 0.22)",
    color: "#b9f2c7",
    fontSize: "17px",
    fontWeight: "800",
  },

  secondaryButton: {
    width: "100%",
    padding: "14px",
    marginTop: "10px",
    borderRadius: "16px",
    border: "1px solid rgba(255,255,255,0.18)",
    background: "rgba(255,255,255,0.07)",
    color: "#fff7e8",
    fontSize: "16px",
    fontWeight: "700",
  },

  deleteButton: {
    width: "100%",
    padding: "14px",
    marginTop: "12px",
    borderRadius: "16px",
    border: "1px solid rgba(255,90,90,0.35)",
    background: "rgba(255,90,90,0.14)",
    color: "#ffb6b6",
    fontSize: "16px",
    fontWeight: "800",
  },

  adminBox: {
    marginTop: "24px",
    paddingTop: "18px",
    borderTop: "1px solid rgba(255,255,255,0.12)",
  },

  counterRow: {
    display: "flex",
    gap: "12px",
    marginBottom: "16px",
  },

  counter: {
    flex: 1,
    background: "rgba(0,0,0,0.22)",
    borderRadius: "18px",
    padding: "14px",
    textAlign: "center",
    border: "1px solid rgba(247,212,138,0.18)",
  },

  participant: {
    background: "rgba(255,255,255,0.06)",
    borderRadius: "14px",
    padding: "12px",
    marginBottom: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    color: "#fff3d7",
  },

  empty: {
    color: "#d8c39b",
    textAlign: "center",
    marginTop: "20px",
  },
};

export default Events;